const name = 'mediaCourse'
export default {
    name,
    namespaced: true,
    state: {
        courseDetail: '',
        courseAudioPlay: ''
    },
    mutations: {
        saveCourseDetail (state, data) {
            state.courseDetail = data
        }
    },
}
